import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withPropsOnChange } from 'recompose';

import { productsProviderV2 } from '../../../hoc/productsProvider';
import withProducts from '../../../hoc/withProducts';
import { INITIAL_MATCHES_STATUS_COMPLETED } from '../../constants';
import { MIN_PAGINATION_ITEMS } from './constants';
import { getMatchesInitializeStatus } from '../../selectors';
import { fetchMatches, resetMatches } from '../../reducer/actions';


const mapStateToProps = state => ({
  isLoadingList: state.isLoadingList,
  list: state.shopify.shopifyMatches.list,
  loadingProducts: Boolean(state.loadingBar),
  matchesInitialized: getMatchesInitializeStatus(state),
});

const mapDispatchToProps = {
  fetchMatches,
  resetMatches,
};

const withMatches = compose(
  productsProviderV2,
  withProducts,
  connect(mapStateToProps, mapDispatchToProps),
  withProps((props) => {
    if (props.isLoadingList || props.loadingProducts) {
      return {
        matches: [],
      };
    }

    const shopifyMatches = props.list
      .map(matchItem => ({
        id: matchItem.id,
        productId: matchItem.itemId,
        type: matchItem.type,
        match: matchItem.matches.find(match => match.vendor === 'shopify'),
      }))
      .filter(matchItem => !!matchItem.match);

    const matches = shopifyMatches.map(({ match, ...restMatchData }) => {
      const matchedProduct = props.products.find(({ id }) => restMatchData.productId === id);

      return {
        ...restMatchData,
        shopifyName: match.data.name,
        squireName: matchedProduct && matchedProduct.name,
        sku: matchedProduct && matchedProduct.sku,
      };
    });

    return {
      matches,
    };
  }),
  withPropsOnChange(['matchesInitialized'],
    (props) => {
      if (props.shopifySettings.initialMatchStatus === INITIAL_MATCHES_STATUS_COMPLETED && !props.loadingMatches) {
        props.fetchMatches(props.brandId, props.shopifySettings, props.status, MIN_PAGINATION_ITEMS, 1);
      }
    }
  ),
  lifecycle({
    componentWillUnmount() {
      this.props.resetMatches();
    },
  })
);

export default withMatches;
